/**
 * Ce que le jeu demande au navigateur : la caméra frontale, JAMAIS le micro. La voix des
 * joueurs n'est ni captée, ni envoyée (pour se parler : un appel à côté).
 */
export const CAMERA_CONSTRAINTS = {
  video: { width: { ideal: 640 }, height: { ideal: 480 }, facingMode: 'user' },
  audio: false,
} as const satisfies MediaStreamConstraints;
